import React, { useState } from 'react'
import { Panel, Row, Col, SelectPicker } from 'rsuite'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function AuditDashboardSearchForm({
  schema,
  loading,
  onSearch = () => {},
  onCancle = () => {},
  ...props
}) {
  const [fiscalYear, setFiscalYear] = useState(schema.fiscalYear.value || '')

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded shaded>
        <Row style={{ marginTop: 10 }}>
          {schema.fiscalYear && (
            <>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {schema.fiscalYear.label}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <SelectPicker
                  data={schema.fiscalYear.options}
                  value={fiscalYear}
                  block
                  onChange={(value) => {
                    setFiscalYear(value)
                  }}
                />
              </Col>
            </>
          )}

          <Col lg={12} md={12} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                onSearch(fiscalYear)
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            />
            <CancelButton
              onClick={() => {
                setFiscalYear('')
                onCancle(fiscalYear)
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
              children="ยกเลิก"
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
